import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: string;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  Decimal: any;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  balance: Scalars['Decimal'];
  id: Scalars['Int'];
  recentAccounts: Array<BankAccountExt>;
  transactions: Array<BankTransaction>;
};


export type BankAccountRecentAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type BankAccountTransactionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type BankAccountExt = {
  __typename?: 'BankAccountExt';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BankAccountExtBalance = {
  __typename?: 'BankAccountExtBalance';
  balance: Scalars['Decimal'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BankTransaction = {
  __typename?: 'BankTransaction';
  amount: Scalars['Decimal'];
  description: Scalars['String'];
  from: BankAccountExt;
  id: Scalars['Int'];
  move: Scalars['Boolean'];
  reverse: Scalars['Boolean'];
  timestamp: Scalars['Timestamp'];
  to: BankAccountExt;
};

export type Book = {
  __typename?: 'Book';
  favorite: Scalars['Boolean'];
  id: Scalars['Int'];
  meals: Array<Meal>;
  name: Scalars['String'];
};

export type Day = {
  __typename?: 'Day';
  date: Scalars['Date'];
  mealsPlanned: Array<Meal>;
};

export type Identity = {
  __typename?: 'Identity';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  state: Scalars['String'];
  state_changed_at: Scalars['DateTime'];
  traits: IdentityTraits;
  updated_at: Scalars['DateTime'];
};

export type IdentityTraits = {
  __typename?: 'IdentityTraits';
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
};

export type Meal = {
  __typename?: 'Meal';
  book?: Maybe<Book>;
  bookId?: Maybe<Scalars['Int']>;
  bookPage?: Maybe<Scalars['Int']>;
  bookmarked: Scalars['Boolean'];
  daysPlanned: Array<Day>;
  id: Scalars['Int'];
  name: Scalars['String'];
  ratingAverage?: Maybe<Scalars['Float']>;
  ratingCount: Scalars['Int'];
  ratingOwn?: Maybe<Scalars['Float']>;
  time?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type MealInputType = {
  bookId?: InputMaybe<Scalars['Int']>;
  bookPage?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  time?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MealPlanned = {
  __typename?: 'MealPlanned';
  date: Scalars['Date'];
  day: Day;
  meal: Meal;
  mealId: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addBankTransaction: BankTransaction;
  addMeal: Meal;
  planMeal: MealPlanned;
  rateMeal: Meal;
  removePlannedMeal: MealPlanned;
  setMealBookmark: Meal;
  updateMeal: Meal;
};


export type MutationAddBankTransactionArgs = {
  amount: Scalars['Decimal'];
  description?: InputMaybe<Scalars['String']>;
  move?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  toId: Scalars['Int'];
};


export type MutationAddMealArgs = {
  input: MealInputType;
};


export type MutationPlanMealArgs = {
  date: Scalars['Date'];
  mealId: Scalars['Int'];
};


export type MutationRateMealArgs = {
  mealId: Scalars['Int'];
  rating?: InputMaybe<Scalars['Int']>;
};


export type MutationRemovePlannedMealArgs = {
  date: Scalars['Date'];
  mealId: Scalars['Int'];
};


export type MutationSetMealBookmarkArgs = {
  bookmarked: Scalars['Boolean'];
  mealId: Scalars['Int'];
};


export type MutationUpdateMealArgs = {
  id: Scalars['Int'];
  input: MealInputType;
};

export type Query = {
  __typename?: 'Query';
  bankAccount?: Maybe<BankAccount>;
  bankAccounts: Array<BankAccountExtBalance>;
  books: Array<Book>;
  day: Day;
  days: Array<Day>;
  meal: Meal;
  meals: Array<Meal>;
  mealsBookmarked: Array<Meal>;
  /** @deprecated replaced with 'day(date: Date!): Day!' */
  mealsByDate: Array<Meal>;
  search: SearchResponse;
  session?: Maybe<Session>;
  suggestMeals: Array<SuggestMeal>;
  users: Array<User>;
};


export type QueryBankAccountsArgs = {
  includeSelf?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBooksArgs = {
  onlyFavorites?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDayArgs = {
  date: Scalars['Date'];
};


export type QueryDaysArgs = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};


export type QueryMealArgs = {
  id: Scalars['Int'];
};


export type QueryMealsByDateArgs = {
  date: Scalars['Date'];
};


export type QuerySearchArgs = {
  searchString: Scalars['String'];
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  books: Array<Book>;
  meals: Array<Meal>;
};

export type Session = {
  __typename?: 'Session';
  active: Scalars['Boolean'];
  authenticated_at: Scalars['DateTime'];
  authenticator_assurance_level: Scalars['String'];
  expires_at: Scalars['DateTime'];
  id: Scalars['ID'];
  identity: Identity;
  issued_at: Scalars['DateTime'];
};

export type SuggestMeal = {
  __typename?: 'SuggestMeal';
  lastPlannedDiff?: Maybe<Scalars['Int']>;
  meal: Meal;
  rating?: Maybe<Scalars['Float']>;
  relevance: Scalars['Float'];
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type SessionQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionQuery = { __typename?: 'Query', session?: { __typename?: 'Session', active: boolean } | null };

export type BooksQueryVariables = Exact<{
  onlyFavorites?: InputMaybe<Scalars['Boolean']>;
}>;


export type BooksQuery = { __typename?: 'Query', books: Array<{ __typename?: 'Book', id: number, name: string }> };

export type MealCardPartsFragment = { __typename?: 'Meal', id: number, name: string, bookmarked: boolean };

export type DaysQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
}>;


export type DaysQuery = { __typename?: 'Query', days: Array<{ __typename?: 'Day', date: string, mealsPlanned: Array<{ __typename?: 'Meal', id: number, name: string, bookmarked: boolean }> }> };

export type DayQueryVariables = Exact<{
  date: Scalars['Date'];
}>;


export type DayQuery = { __typename?: 'Query', day: { __typename?: 'Day', date: string, mealsPlanned: Array<{ __typename?: 'Meal', id: number, name: string, bookmarked: boolean }> } };

export type MealQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MealQuery = { __typename?: 'Query', meal: { __typename?: 'Meal', id: number, name: string, time?: number | null, url: string, bookPage?: number | null, bookmarked: boolean, ratingAverage?: number | null, ratingCount: number, ratingOwn?: number | null, book?: { __typename?: 'Book', id: number, name: string } | null, daysPlanned: Array<{ __typename?: 'Day', date: string }> } };

export type MealNameQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MealNameQuery = { __typename?: 'Query', meal: { __typename?: 'Meal', id: number, name: string } };

export type MealsQueryVariables = Exact<{ [key: string]: never; }>;


export type MealsQuery = { __typename?: 'Query', meals: Array<{ __typename?: 'Meal', id: number, name: string, bookmarked: boolean }> };

export type SearchQueryVariables = Exact<{
  searchString: Scalars['String'];
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'SearchResponse', meals: Array<{ __typename?: 'Meal', id: number, name: string, bookmarked: boolean }> } };

export type SuggestMealsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestMealsQuery = { __typename?: 'Query', suggestions: Array<{ __typename?: 'SuggestMeal', meal: { __typename?: 'Meal', id: number, name: string, bookmarked: boolean } }> };

export type MealsBookmarkedQueryVariables = Exact<{ [key: string]: never; }>;


export type MealsBookmarkedQuery = { __typename?: 'Query', meals: Array<{ __typename?: 'Meal', id: number, name: string, bookmarked: boolean }> };

export type PlanMealMutationVariables = Exact<{
  mealId: Scalars['Int'];
  date: Scalars['Date'];
}>;


export type PlanMealMutation = { __typename?: 'Mutation', planMeal: { __typename?: 'MealPlanned', day: { __typename?: 'Day', date: string }, meal: { __typename?: 'Meal', id: number, name: string, bookmarked: boolean } }, setMealBookmark: { __typename?: 'Meal', id: number, name: string, bookmarked: boolean } };

export type RemovePlannedMealMutationVariables = Exact<{
  mealId: Scalars['Int'];
  date: Scalars['Date'];
}>;


export type RemovePlannedMealMutation = { __typename?: 'Mutation', removePlannedMeal: { __typename?: 'MealPlanned', day: { __typename?: 'Day', date: string }, meal: { __typename?: 'Meal', id: number, name: string, bookmarked: boolean } } };

export type MovePlannedMealMutationVariables = Exact<{
  mealId: Scalars['Int'];
  date: Scalars['Date'];
  oldDate: Scalars['Date'];
}>;


export type MovePlannedMealMutation = { __typename?: 'Mutation', removePlannedMeal: { __typename?: 'MealPlanned', day: { __typename?: 'Day', date: string }, meal: { __typename?: 'Meal', id: number, name: string, bookmarked: boolean } }, planMeal: { __typename?: 'MealPlanned', day: { __typename?: 'Day', date: string }, meal: { __typename?: 'Meal', id: number, name: string, bookmarked: boolean } } };

export type AddMealMutationVariables = Exact<{
  input: MealInputType;
}>;


export type AddMealMutation = { __typename?: 'Mutation', meal: { __typename?: 'Meal', id: number, name: string, time?: number | null, url: string, bookPage?: number | null, bookmarked: boolean, book?: { __typename?: 'Book', id: number, name: string } | null } };

export type UpdateMealMutationVariables = Exact<{
  mealId: Scalars['Int'];
  input: MealInputType;
}>;


export type UpdateMealMutation = { __typename?: 'Mutation', meal: { __typename?: 'Meal', id: number, name: string, time?: number | null, url: string, bookPage?: number | null, book?: { __typename?: 'Book', id: number, name: string } | null } };

export type SetMealBookmarkMutationVariables = Exact<{
  mealId: Scalars['Int'];
  bookmarked: Scalars['Boolean'];
}>;


export type SetMealBookmarkMutation = { __typename?: 'Mutation', meal: { __typename?: 'Meal', id: number, name: string, bookmarked: boolean } };

export type RateMealMutationVariables = Exact<{
  mealId: Scalars['Int'];
  rating?: InputMaybe<Scalars['Int']>;
}>;


export type RateMealMutation = { __typename?: 'Mutation', meal: { __typename?: 'Meal', id: number, ratingAverage?: number | null, ratingCount: number, ratingOwn?: number | null } };

export const MealCardPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MealCardParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Meal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bookmarked"}}]}}]} as unknown as DocumentNode<MealCardPartsFragment, unknown>;
export const SessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<SessionQuery, SessionQueryVariables>;
export const BooksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Books"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyFavorites"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"books"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyFavorites"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyFavorites"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<BooksQuery, BooksQueryVariables>;
export const DaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Days"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"mealsPlanned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<DaysQuery, DaysQueryVariables>;
export const DayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Day"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"mealsPlanned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<DayQuery, DayQueryVariables>;
export const MealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Meal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookPage"}},{"kind":"Field","name":{"kind":"Name","value":"daysPlanned"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookmarked"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAverage"}},{"kind":"Field","name":{"kind":"Name","value":"ratingCount"}},{"kind":"Field","name":{"kind":"Name","value":"ratingOwn"}}]}}]}}]} as unknown as DocumentNode<MealQuery, MealQueryVariables>;
export const MealNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MealName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MealNameQuery, MealNameQueryVariables>;
export const MealsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Meals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<MealsQuery, MealsQueryVariables>;
export const SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
export const SuggestMealsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuggestMeals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"suggestions"},"name":{"kind":"Name","value":"suggestMeals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<SuggestMealsQuery, SuggestMealsQueryVariables>;
export const MealsBookmarkedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MealsBookmarked"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"meals"},"name":{"kind":"Name","value":"mealsBookmarked"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<MealsBookmarkedQuery, MealsBookmarkedQueryVariables>;
export const PlanMealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlanMeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planMeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"setMealBookmark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookmarked"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<PlanMealMutation, PlanMealMutationVariables>;
export const RemovePlannedMealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePlannedMeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePlannedMeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<RemovePlannedMealMutation, RemovePlannedMealMutationVariables>;
export const MovePlannedMealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MovePlannedMeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePlannedMeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"planMeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<MovePlannedMealMutation, MovePlannedMealMutationVariables>;
export const AddMealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MealInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"meal"},"name":{"kind":"Name","value":"addMeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookPage"}},{"kind":"Field","name":{"kind":"Name","value":"bookmarked"}}]}}]}}]} as unknown as DocumentNode<AddMealMutation, AddMealMutationVariables>;
export const UpdateMealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MealInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"meal"},"name":{"kind":"Name","value":"updateMeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookPage"}}]}}]}}]} as unknown as DocumentNode<UpdateMealMutation, UpdateMealMutationVariables>;
export const SetMealBookmarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMealBookmark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookmarked"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"meal"},"name":{"kind":"Name","value":"setMealBookmark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookmarked"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookmarked"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MealCardParts"}}]}}]}},...MealCardPartsFragmentDoc.definitions]} as unknown as DocumentNode<SetMealBookmarkMutation, SetMealBookmarkMutationVariables>;
export const RateMealDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RateMeal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"meal"},"name":{"kind":"Name","value":"rateMeal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mealId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mealId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAverage"}},{"kind":"Field","name":{"kind":"Name","value":"ratingCount"}},{"kind":"Field","name":{"kind":"Name","value":"ratingOwn"}}]}}]}}]} as unknown as DocumentNode<RateMealMutation, RateMealMutationVariables>;